"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mxw_libs_utils_1 = require("mxw-libs-utils");
function checkPayload(data) {
    return mxw_libs_utils_1.checkFormat({
        payload: {
            data: {
                ac: mxw_libs_utils_1.checkString,
                id: mxw_libs_utils_1.checkString,
                ch: mxw_libs_utils_1.allowNullOrEmpty(mxw_libs_utils_1.checkString),
                pk: mxw_libs_utils_1.allowNullOrEmpty(mxw_libs_utils_1.checkAny),
                msg: mxw_libs_utils_1.allowNullOrEmpty(mxw_libs_utils_1.checkAny)
            },
            items: mxw_libs_utils_1.allowNullOrEmpty(mxw_libs_utils_1.checkAny),
            type: mxw_libs_utils_1.checkString
        },
        pubKey: {
            type: mxw_libs_utils_1.allowNullOrEmpty(mxw_libs_utils_1.checkString),
            value: mxw_libs_utils_1.allowNullOrEmpty(mxw_libs_utils_1.checkString)
        },
        signature: mxw_libs_utils_1.checkString,
    }, data);
}
exports.checkPayload = checkPayload;
//# sourceMappingURL=interface.js.map